class Loader {
  constructor() {
    this.loader = document.querySelector('#loader');
  }

  show() {
    this.loader?.classList.remove('hidden');
  }

  hide() {
    this.loader?.classList.add('hidden');
  }
}

export const loader = new Loader();
